import { useEffect, useRef, useState } from 'react'
import hipersendService from '../../../services/hipersend'
import { templatesAprovados, idiomaSaiNoEnvio } from '../../../libs/metaTemplates'

// Modelos que podem sair num envio em massa: aprovados pela Meta e em pt_BR
// (o envio sai sempre em pt_BR; a Meta recusaria o resto). Usado pelo seletor
// do agendamento e pela escolha de modelo do disparo.
//
// `onCarregou(modelos)` roda uma vez, quando a lista chega — o agendamento
// usa para reabrir o modelo que estava salvo.
export default function useModelosAprovados(api, secret, { onCarregou } = {}) {
  const [modelos, setModelos] = useState([])
  const [carregando, setCarregando] = useState(false)
  const [erro, setErro] = useState('')
  const avisar = useRef(onCarregou)
  avisar.current = onCarregou

  useEffect(() => {
    if (!api || !secret) return undefined
    let vivo = true

    setCarregando(true)
    setErro('')
    hipersendService.metaTemplates
      .list(api, secret)
      .then((resposta) => {
        if (!vivo) return
        const aprovados = templatesAprovados(resposta).filter(idiomaSaiNoEnvio)
        setModelos(aprovados)
        if (avisar.current) avisar.current(aprovados)
      })
      .catch(() => { if (vivo) setErro('Não foi possível carregar os modelos aprovados') })
      .finally(() => { if (vivo) setCarregando(false) })

    return () => { vivo = false }
  }, [api, secret])

  return { modelos, carregando, erro }
}
